module.exports = __webpack_public_path__ + "static/media/placeholder.b81b5b8b.png";